module.exports = __webpack_public_path__ + "img/close-o.b0a8753e.png";